// PADELISM: "+ Add" button in the cart drawer cross-sell row. Uses the same cart event as Fabric's own
// add-to-cart, so the drawer, cart count and free delivery bar all refresh on their own.
import { CartLinesUpdateEvent } from '@shopify/events';

class PdlmCartAdd extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('change', this.#onChange);
  }

  #onChange = (event) => {
    const select = event.target.closest('select[data-pdlm-variant]');
    const price = this.querySelector('[data-pdlm-price]');
    if (select && price) price.textContent = select.selectedOptions[0]?.dataset.price || price.textContent;
  };

  #onClick = async (event) => {
    const button = event.target.closest('[data-pdlm-add]');
    if (!button) return;
    const variantId = Number(this.querySelector('[data-pdlm-variant]')?.value);
    if (!variantId) return;
    button.setAttribute('aria-busy', 'true');

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds.join(',') }),
      }).then((r) => r.json());
      const cart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'pdlm-cart-add',
          itemCount: 1,
          sections: response.status ? undefined : response.sections,
          didError: Boolean(response.status),
        },
      });
    } catch (error) {
      deferred.reject(error);
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('pdlm-cart-add')) customElements.define('pdlm-cart-add', PdlmCartAdd);
